// TODO запускать только где есть лента


import now from 'lodash/now';
import forEach from 'lodash/forEach';
import last from 'lodash/last';
import each from 'lodash/each';
import extend from 'lodash/extend';
import isEmpty from 'lodash/isEmpty';
import isArray from 'lodash/isArray';
import every from 'lodash/every';
import debounce from 'lodash/debounce';


import store from './util/store';
import main from './util/main';
import log from './util/log';

import {on} from './util/event'
import userInteresting from './userInteresting'

const events = {
  fetchNext: 'fetchNext.kiosk.feed',
}

  let
      $feedContainer,
      pagination,
      $document,
      $showBeforeHide,
      $showAfterHide,
      $overflowWhite,
      pageWithFeed = false,
      _mainFeed = false,
      _recommendedFeed = false,
      _wasInitOnPageWithFeed = false,
      $overflow,
      items = {},
      itemsOrder = [],
      itemsRowOrder = [],
      _itemsBeforeOld = [],
      _itemsAfterOld = [],
      _cacheState = {
        timestamp: now(),
        ids: [],
        active: false,
        sid: 0,
        page: 0
      },
      $_body = $("body"),
      $_html = $("html, body"),
      _xhrComplete = true,
      _feedReloadXhrComplete = true,
      _feedNeedReload = false,
      _scrollingToPost = false,
      _isFeedOverflow = false,
      _currentId = 0,
      _lastCheckTime = 0,
      _needSaveState = false, // only if click on .to-comments
      _currentPage = 0,
      _currentPaginationKey = null,
      _pageFromStateRestore = 0,
      _nextPage = 0,
      _prevPage = 0,
      _hideBeforeDebounce,
      _feedInterestingChangeDebounce,
      _lastWindowWidth,
      _lastWindowHeight,
      _countBeforeCurrent,
      _countAfterCurrent,

      $_restorePopover,

      _countRowsBeforeCurrent,
      _countRowsAfterCurrent,

      _currentHide,
      _cacheStatePrevious,

      constMinItemsBeforeToHide = 12, // если перед текущим item будет больше items чем constMinItemsBeforeToHide - то скрываем
      S = constMinItemsBeforeToHide / 2,

      constMinItemsAfterToHide = 26, // // если после текущего item будет больше items чем constMinItemsAfterToHide - то скрываем
      T = constMinItemsAfterToHide / 2,
      N = 1,


      _checkPath = function() {
        var pathname = window.location.pathname,
            test = ["/", "/index", "/bookmarks"],
            // regTest = [/^\/article\/by-magazine\/.*$/, /^\/article\/category\/.*$/],
            regTest = [/^\/magazine\/.*$/, /^\/article\/by-magazine\/.*$/, /^\/articles\/category\/.*$/, /^\/article\/.*$/],
            match = false;

        if (test.indexOf(pathname) !== -1) {
          return true;
        }
        forEach(regTest, function(item) {
          if (item.test(pathname)) {
            match = true;
          }
        });

        return match;
      },

      _checkIsMainFeed = function() {
        var pathname = window.location.pathname,
            test = ["/", "/index"];

        if (test.indexOf(pathname) !== -1) {
          return true;
        }
        return false;
      },

      _checkIsRecommendedFeed = function() {
        var pathname = window.location.pathname,
            regTest = [/^\/article\/.*$/],
            match = false;

        forEach(regTest, function(item) {
          if (item.test(pathname)) {
            match = true;
          }
        });

        return match;
      },

      _checkCurrentPage = function ($context) {

        // log.print('trigger check current page');

        pageWithFeed = _checkPath();

        _mainFeed = _checkIsMainFeed();

        _recommendedFeed = _checkIsRecommendedFeed();

        // pageWithFeed = window.location.pathname === "/" || window.location.pathname === "/index";

        $feedContainer = $('.articles-container-row');
        pagination = $feedContainer.hasClass('with-pagination');
        $document = $(window.document);
        $showBeforeHide = $('.show-before-pages');
        $showAfterHide = $('.show-after-pages');

        // на каждой странице - полная переинициализация и поиск текущей page
        var page = reInit(true);
        // log.print('__feed__', 'context', $context);
        // log.print('__feed__', 'set current page', page);
        // log.print('__feed__', 'set current pages', items);
        _setCurrentPage(page);

      },

      _setCurrentPage = function (page) {
        _currentPage = page;
        _prevPage = page - 1;
        _nextPage = page + 1;

        $showAfterHide.attr('href', window.location.origin + window.location.pathname + "?" + decodeURIComponent('page=' + _nextPage + (_currentPaginationKey ? ('&key=' + _currentPaginationKey) : '')));

      },
      _hideBefore = function (e) {
        var list,
            n;

        if (_countRowsBeforeCurrent <= constMinItemsBeforeToHide) {
          return;
        }
        _currentHide = true;
        list = itemsOrder.splice(0, _countBeforeCurrent);
        n = e - items[_currentId].offset().top;
        items[last(list)].prevAll(".feed_ad_wrapper, .user-tips").remove();
        removeItems(list);
        _itemsBeforeOld = _itemsBeforeOld.concat(list);
        _setCurrentItem(_currentId, true);
        _scrollingToPost = true;

        // если была кнопка
        // !$showBeforeHide.is(":visible") && $showBeforeHide.show();

        $_html.scrollTop(items[_currentId].offset().top + n);
        setTimeout(function () {
          $_html.scrollTop(items[_currentId].offset().top + n)
        }, 50);
        setTimeout(function () {
          _scrollingToPost = false;
          _currentHide = false;
        }, 500);

        log.print(":feed:", "hideBefore", list);

      },
      _hideAfter = function () {
        var e, t;
        _currentHide = !0;
        t = $showAfterHide.is(":visible");
        e = itemsOrder.splice(itemsOrder.length - 1 - T, T);
        removeItems(e);
        _itemsAfterOld = e.concat(_itemsAfterOld);
        _setCurrentItem(_currentId, true);
        !t && $showAfterHide.show();
        _currentHide = false;

      },

      removeItems = function (list) {
        list = isArray(list) ? list.slice() : [list];
        forEach(list, function (id) {
          var itemsOrderIndex,
              itemsRowOrderIndex;
          if (!items[id])
            return true;

          items[id].remove();
          delete items[id];
          itemsOrderIndex = itemsOrder.indexOf(id);
          if (itemsOrderIndex > -1) {
            itemsOrder.splice(itemsOrderIndex, 1);
          }
          itemsRowOrderIndex = itemsRowOrder.indexOf(id); // если элемент стоит в начале строки - то попадет
          if (itemsRowOrderIndex > -1) {
            itemsRowOrder.splice(itemsRowOrderIndex, 1);
          }
        });
      },
      _setCurrentItem = function (id, t) {
        if (!t && (_scrollingToPost || _currentId === id)) {
          return;
        }
        // log.print("_setCurrentItem", id);
        _currentId = id;
        _countBeforeCurrent = itemsOrder.indexOf(id) - 1;
        _countAfterCurrent = itemsOrder.length - _countBeforeCurrent;

        _countRowsBeforeCurrent = itemsRowOrder.indexOf(id) - 1;
        _countRowsAfterCurrent = itemsRowOrder.length - _countRowsAfterCurrent;

      },
      reInit = function(t) {
        var lastOffsetTop,
            page = 0;
        if (t) {
          _itemsAfterOld  = [];
          _itemsBeforeOld = [];
          // $showBeforeHide.hide();
          // $showAfterHide.hide();
          _isFeedOverflow = false;

          items = [];
          _currentPaginationKey = $feedContainer.data('pagination-key') || null;
        }

        itemsOrder    = [];
        itemsRowOrder = [];
        forEach($feedContainer.find('.article-item-wrapper-item'), function(item) {
          var id = item.getAttribute("data-item-id"),
              offsetTop,
              isVisible;
          if (!items[id]) {
            items[id] = $(item);
          }
          offsetTop = items[id].offset().top;
          isVisible = items[id].is(":visible");

          if (isVisible) {
            itemsOrder.push(id);
            if (lastOffsetTop !== offsetTop) {
              itemsRowOrder.push(id);
              lastOffsetTop = offsetTop;
            }
          }

          page = items[id].data('page'); // zero based

        });
        page++;

        if (!_currentId && itemsOrder[0]) {
          _setCurrentItem(itemsOrder[0]);
        }
        _lastWindowWidth  = $(window).width();
        _lastWindowHeight = $(window).height();
        $overflow && $overflow.remove();

        // log.info("reInit", "itemsRowOrder", itemsRowOrder);
        return page;
      },

      _getHistoryLength = function () {
        return history.length - (main.ua.platform.type === "desktop" && main.ua.browser.name === "Chrome" ? 1 : 0)
      },
      _addBeforeUnload = function () {
        $(window).on(main.ua.os.name === "iOS" ? "pagehide" : "beforeunload", function () {

          if (pageWithFeed) {
            if (!_needSaveState || _currentPage < N) {
              _cacheState = {};
            } else {
              extend(_cacheState, {
                timestamp: now(),
                ids: itemsOrder,
                idsBefore: _itemsBeforeOld,
                idsAfter: _itemsAfterOld,
                sid: _currentId,
                page: items[_currentId].data('page') + 1, // from zerobased
                active: false
              });

              // console.info(":restore:", "save", _cacheState);
            }
          } else {
            if (_cacheStatePrevious && !_cacheStatePrevious.active && _cacheStatePrevious.page > 0) {
              _cacheState = _cacheStatePrevious;
              // активируем только не со страницы ленты
              if (_cacheState !== undefined) {
                _cacheState.active = true;
              }
            } else {
              _cacheState = {};
            }

          }
          store.set("_p_cache", _cacheState)
        })
      },

      _attachEvents = function() {
        $feedContainer.on("click", "a.article-cover", function() {
          _needSaveState = true;
          _setCurrentItem($(this).parents(".article-item-wrapper-item").data("item-id"), true);
          return true;
        });

        //
        on(userInteresting.changedEventName, _feedInterestingChangeDebounce);

      },
      _attachScroll = function () {
        // $showBeforeHide.click(utils.bind(_getPrevItems, this, true));
        // main.on("document:scroll", utils.bind(_scrollFeed, this));
        main.on("document:scroll", _scrollFeed);

        // r(window).on("orientationchange", i.bind(this._changeOrientation, this)),
        // r(document).on("webkitfullscreenchange mozfullscreenchange fullscreenchange", i.bind(this._changeFullscreen, this)),
      },
      _scrollFeed = function (scrollTop) {

        // log.print(":feed:", "scroll", {scrollTop: scrollTop, currentPage: _currentPage, _scrollingToPost: _scrollingToPost, _currentId: _currentId});

        if (_scrollingToPost || !_currentId || !pageWithFeed)
          return;
        _getItemsViewport(scrollTop);

        // var item = items[_currentId][0];

        // if (!u.config("twitMode"))
        //     return this;

        if (_countRowsBeforeCurrent > constMinItemsBeforeToHide && !_currentHide) {
          if (main.isMobile) {
            // _hideBeforeDebounce(scrollTop);
          }
        } else {
          if (_countRowsAfterCurrent > constMinItemsAfterToHide && !_currentHide) {
            return;
            // return _hideAfter(scrollTop);
          }
          if (_countRowsAfterCurrent < T && !isEmpty(_itemsAfterOld)) {
            // грузим страые после восстановления todo add return
            _getPrevItems(false);
          }
        }

        if (now() - _lastCheckTime > 2000 && ($document.height() - scrollTop < 1500 || _countRowsAfterCurrent < 5)) {
          _lastCheckTime = now();
          // log.print(":feed:", "beforeGetNextItem", {scrollTop: scrollTop, currentPage: _currentPage});
          _getNextItems();
        } else if ($document.height() - scrollTop < 1500 || _countRowsAfterCurrent < 5) {
          // log.print(":feed:", "beforeGetNextItem", {scrollTop: scrollTop, currentPage: _currentPage});
          _getNextItems();
        }

        // log.print(":feed:", "beforeLoadPrev", {scrollTop: scrollTop, currentPage: _currentPage});

        // крутим вверх, текущая страница не 1 хранить loadedPages
        // if (scrollTop < 1500 && _currentPage > 1 && !utils.isEmpty(_itemsBeforeOld)) {
        //     log.print(":feed:", "beforeLoadPrev", {scrollTop: scrollTop, currentPage: _currentPage});
        //     _getPrevItems(true); // TODO объединить загрузку страниц, добавить id и тип сетки если нужно (только при восстановлении и только на конкретную страницу (про тип сетки)
        // }


        if (scrollTop < 1500 && _currentPage > 1 && _pageFromStateRestore > 1) {
          // log.print(":feed:", "beforeLoadPrev", {scrollTop: scrollTop, currentPage: _currentPage});
          _getPrevItems(false); // TODO объединить загрузку страниц, добавить id и тип сетки если нужно (только при восстановлении и только на конкретную страницу (про тип сетки)
        }

      },
      scrollToItem = function(id, t) {
        var r, t;
        // if (!items[id]) {
        //     return;
        // }
        t = items[id] ? (r = !t || t > 1 ? 0 : items[id].height() * t,
          _scrollingToPost = true,
          $_html.scrollTop(items[id].offset().top - 45 + r),
          setTimeout(function() {
            _scrollingToPost = false;
          }, 600),
          this) : this;
        _scrollingToPost = false;
      },
      _checkScrollTop = function(id, t) {
        var scrollTop = $_body.scrollTop(),
            n;
        if (items[id]) {
          n = items[id].offset().top - 45 + (t ? items[id].height() * t : 0);
          return scrollTop - 50 < n && scrollTop + 50 > n;
        }
        return false;
      },
      _getItemsViewport = function (scrollTop) {
        var n = scrollTop - window.innerHeight,
            s = scrollTop + 150,
            windowWidth = $(window).width(),
            windowHeight = $(window).height(),
            currentIndex = 0;
        // return w && w.isFullscreen ? !0 :

        every(itemsOrder, function (index) {
          var item = items[index],
              offsetTop = item.offset().top;

          if (!(offsetTop + item.height() < n || offsetTop > s)) {
            if (itemsRowOrder.indexOf(index) !== -1) {
              currentIndex = index;
            }
            // log.info("through index", index);
          }
          return offsetTop < s;
        });

        if (currentIndex && (_lastWindowWidth === windowWidth || _lastWindowHeight === windowHeight)) {
          _setCurrentItem(currentIndex);
        }
        _lastWindowWidth = $(window).width();
        _lastWindowHeight = $(window).height();

        return true;
      },


      _getPrevItems = function (e) {
        var idsToLoad, s;

        // log.print(":feed:", "initLoadPrevItems", "pageToLoad", _prevPage);

        if (!_xhrComplete || _isFeedOverflow) {
          return;
        }

        $showBeforeHide.show();

        // main.config("GET").page = _nextPage;
        _xhrComplete = false;

        if (e) {
          // TODO rows
          idsToLoad = _itemsBeforeOld.splice(_itemsBeforeOld.length - constMinItemsBeforeToHide, constMinItemsBeforeToHide).reverse();
        } else {
          idsToLoad = _itemsAfterOld.splice(0, constMinItemsBeforeToHide);
        }

        $.ajax({
          // url: window.location.origin + window.location.pathname + "?" + decodeURIComponent($.param(main.configGet)),
          // url: window.location.origin + window.location.pathname + "?" + decodeURIComponent('page=' + _prevPage),
          url: window.location.origin + window.location.pathname,
          type: "GET",
          dataType: "json",
          data: {
            page: _prevPage,
            action: "load_items",
            ids: idsToLoad
          }
        }).then(function (response) {
          var lastId, $fragment, loadedIds = [];

          try {
            if (!response.result) {
              return false;
            }

            if (e) {
              s = $document.scrollTop() - items[_currentId].offset().top;
            }
            // if (utils.isEmpty(_itemsBeforeOld)) {
            //     $showBeforeHide.hide();
            // }
            _scrollingToPost = true;
            $fragment = $(document.createDocumentFragment());
            forEach(response.data.items, function(item) {
              $fragment[e ? "prepend" : "append"](item.html);
              lastId = item.id;
              loadedIds.push(item.id);
            });
            // $feedContainer[e ? "prepend" : "append"]($fragment);
            $feedContainer.prepend($fragment);
            reInit();

            _currentPage = _prevPage;
            _prevPage = _currentPage - 1;
            // TODO удалять последгюю страницу ??? (после текущей)
            // _setCurrentPage(_nextPage);
            _setCurrentItem(_currentId, true);

            if (e && lastId) {
              setTimeout(function () {
                $_html.scrollTop(items[_currentId].offset().top + s)
              }, 200)
            }
            _scrollingToPost = false;

            // log.print(":feed:", "loadedOldIds", loadedIds);

          } catch (exception) {
            log.error(":feed:", "bad load old", exception);
          }

          //
          //
          //
          // var _itemsCount = 0;
          // if (!response.result)
          //     return this;
          // response.data.is_feed_overflow = Boolean(response.data.is_feed_overflow);
          //
          // if (response.data.items.length === 0 || response.data.is_feed_overflow) {
          //     console.warn("feed is overflow", response.data);
          //     return main.trigger("end", _isFeedOverflow = true), this;
          // }
          //
          // var fragment = $(document.createDocumentFragment()),
          //     _item,
          //     _items = [];
          //
          // utils.each(response.data.items, function (item) {
          //     if (!items[item.id] && _itemsBeforeOld.indexOf(item.id) === -1 && _itemsAfterOld.indexOf(item.id) === -1) {
          //         _items.push(item);
          //         _itemsCount++;
          //     }
          // });
          // for (var i = 0; i < _itemsCount; i++) {
          //     _item = _items[i];
          //     fragment.append($(_item.html));
          // }
          // $feedContainer.append(fragment);
          // reInit();
          // _setCurrentPage(_nextPage);
          // _setCurrentItem(_currentId, true)
        }, function(response){
          log.error(":feed:", "bad load old", response)
        }).always(function () {
          _xhrComplete = true;
          $showBeforeHide.hide();
          // $showBeforeHide.hide();
        });

      },
      _getNextItems = function () {

        if (!_xhrComplete || _isFeedOverflow) {
          return;
        }

        // $showAfterHide.show();

        $showAfterHide.addClass('loading');

        // main.config("GET").page = _nextPage;
        _xhrComplete = false;

        // log.print('__feed__', 'request next page', _nextPage);
        $.ajax({
          // url: window.location.origin + window.location.pathname + "?" + decodeURIComponent($.param(main.configGet)),
          url: window.location.origin + window.location.pathname + "?" + decodeURIComponent('page=' + _nextPage + (_currentPaginationKey ? ('&key=' + _currentPaginationKey) : '')),
          timeout: 10000,
          type: "GET",
          dataType: "json"
        }).done(function (response) {
          var _itemsCount = 0;
          if (!response.result)
            return this;
          response.data.is_feed_overflow = Boolean(response.data.is_feed_overflow);

          if (response.data.items.length === 0 || response.data.is_feed_overflow) {
            $showAfterHide.hide();
            // console.warn("feed is overflow", response.data);
            return main.trigger("end", _isFeedOverflow = true), this;
          }

          let fragment = $(document.createDocumentFragment()),
              _item,
              _items = [];

          each(response.data.items, function (item) {
            if (!items[item.id] && _itemsBeforeOld.indexOf(item.id) === -1 && _itemsAfterOld.indexOf(item.id) === -1) {
              _items.push(item);
              _itemsCount++;
            }
          });
          for (let i = 0; i < _itemsCount; i++) {
            _item = _items[i];
            fragment.append($(_item.html));
          }
          $feedContainer.append(fragment);
          reInit();
          _setCurrentPage(_nextPage);
          _setCurrentItem(_currentId, true)
        }).always(function () {
          _xhrComplete = true;
          // $showAfterHide.hide();

          $showAfterHide.removeClass('loading');

        });


      },
      checkNeedRestore = function() {
        _cacheStatePrevious = {};
        extend(_cacheStatePrevious, _cacheState, store.get("_p_cache") || {});
        if (_cacheStatePrevious.ids.length > 0) {
          log.print(":restore:", "Store is enabled", _cacheStatePrevious);

          if (pageWithFeed && _cacheStatePrevious.active && !isEmpty(_cacheStatePrevious.ids) && now() - _cacheStatePrevious.timestamp < 1500000 && _getHistoryLength() > 1) {
            log.print(":cache:", "ready to used cache");

            _cacheState = _cacheStatePrevious;
            restoreState(_cacheState);
            _cacheState.active = false;
            _setCurrentPage(_cacheState.page);
            store.set("_p_cache", _cacheState);

          }
          return false;
        }
        return false;
      },
      _showRestoreMessage = function(show) {

        if (!$_restorePopover) {
          $_restorePopover = $(APP.templates["feed/restore.html"]).appendTo($_body);
        }

        if (show) {
          // $_html.css({overflow: "hidden"});
          $_restorePopover.popover("show");
        } else {
          // $_html.css({overflow: "auto"});
          $_restorePopover.popover("hide");
        }
      },

      empty = function() {
        removeItems(itemsOrder);
        $feedContainer.empty();
      },
      emptyWithFade = function() {
        // TODO make via Promise
        // 0.15s
        var d = $.Deferred();
        $feedContainer.removeClass('show');
        setTimeout(function() {
          removeItems(itemsOrder);
          $feedContainer.empty();
          d.resolve();
        }, 150);
        return d.promise();
      },
      showWithFade = function() {
        // 0.15s
        var d = $.Deferred();
        $feedContainer.addClass('show');
        setTimeout(function() {
          d.resolve();
        }, 150);
        return d.promise();
      },
      _overflowWhiteToggle = function(show) {
        if (!$overflowWhite || !$overflowWhite.length) {
          $overflowWhite = $(document.createElement("div")).addClass("feed_background").addClass("fade").prependTo($feedContainer);
        }
        if (show) {
          // $overflowWhite.show();
          $overflowWhite.addClass("show");
        } else {
          $overflowWhite.removeClass("show");
          $overflowWhite.remove();
          // setTimeout(function() {
          //     $overflowWhite.hide();
          // }, 300);
          // $overflowWhite.toggleClass("feed__overflow-white_hide", !show);
        }
      },
      restoreState = function(restoreState) {
        if (!_xhrComplete) {
          return;
        }

        _xhrComplete    = false;
        _itemsAfterOld  = restoreState.idsAfter || [];
        _itemsBeforeOld = restoreState.idsBefore || [];

        if (!isEmpty(_itemsBeforeOld)) {
          $showBeforeHide.show();
        }

        _showRestoreMessage(true);
        setTimeout(function() {
          _showRestoreMessage(true);
        }, 150);
        empty();
        _overflowWhiteToggle(true);
        _scrollingToPost = true;

        $.ajax({
          // url: window.location.origin + window.location.pathname + "?" + decodeURIComponent($.param(main.configGet)),
          url: window.location.origin + window.location.pathname + "?" + decodeURIComponent('page=' + restoreState.page),
          type: "GET",
          dataType: "json"
          // action: "load_stories",
          // ids: data.ids,
        }).then(function(response) {

          if (!response.result)
            return;

          try {
            var $fragment = $(document.createDocumentFragment());
            each(response.data.items, function(e) {
              $fragment.append(e.html)
            });
            $feedContainer.append($fragment);
            setTimeout(function() {
              reInit();

              _pageFromStateRestore = restoreState.page;

              _setCurrentPage(restoreState.page);
              _setCurrentItem(restoreState.sid, true);
              scrollToItem(restoreState.sid);
              setTimeout(function() {
                if (_checkScrollTop(restoreState.sid, 0)) {
                  _showRestoreMessage(false);
                  _overflowWhiteToggle(false);
                } else {
                  _showRestoreMessage(false);
                  _overflowWhiteToggle(false);
                  // scrollToItem(Number(restoreState.sid), 0);
                  // setTimeout(function() {
                  //     if (!_checkScrollTop(Number(restoreState.sid), 0)) {
                  //         scrollToItem(Number(restoreState.sid), 0);
                  //     }
                  //     _showRestoreMessage(false);
                  //     _overflowWhiteToggle(false);
                  // }, 600);
                }
              }, 600)
            }, 1500);
          } catch (exception) {
            log.error(":feed:", "bad loadState", restoreState, exception);
            _showRestoreMessage(false);
          }
        }, function(response) {
          log.error(":feed:", "bad loadState", response);
          _showRestoreMessage(false);
        })
          .always(function() {
            _xhrComplete = true;
          });

      },

      _feedInterestingChange = function (e) {

        if (!_mainFeed && !_recommendedFeed) {
          return;
        }

        if (!_feedReloadXhrComplete) {
          _feedNeedReload = true;
          return;
        }

        _feedReloadXhrComplete = false;

        var scrollTop = 0;
        if (_recommendedFeed) {
          // scrollTop = $feedContainer.get(0).scrollHeight;
          scrollTop = null;
        }

        $.ajax({
          // url: window.location.origin + window.location.pathname + "?" + decodeURIComponent($.param(main.configGet)),
          url: window.location.origin + window.location.pathname + "?" + decodeURIComponent('page=1'),
          type: "GET",
          dataType: "json"
        }).then(function(response) {

          if (!response.result)
            return;

          try {
            var $fragment = $(document.createDocumentFragment());
            each(response.data.items, function(e) {
              $fragment.append(e.html)
            });

            _scrollingToPost = true;
            emptyWithFade().done(function(){

              if (scrollTop !== null) {
                $_html.scrollTop(scrollTop);
              }
              $feedContainer.append($fragment);

              showWithFade();

              reInit(true);
              _setCurrentPage(1);

              _scrollingToPost = false;

            });

          } catch (exception) {
            // log.error(":feed:", "bad loadState", restoreState, exception);
            // _showRestoreMessage(false);
          }
        }, function(response) {
          // log.error(":feed:", "bad loadState", response);
          // _showRestoreMessage(false);
        })
          .always(function() {
            _feedReloadXhrComplete = true;

            if (_feedNeedReload) {
              _feedNeedReload = false;
              _feedInterestingChange();
            }

          });

        // log.print(":feed:", "_feedInterestingChange", e);

      }
  ;

  // START

  _checkCurrentPage();

  // TODO если зашли со страницы статьи, но есть popState - как то хранить объект feed для последующей работы ?
  if (pageWithFeed) {

    _wasInitOnPageWithFeed = true;

    _setCurrentPage(1);
    // _hideBeforeDebounce = utils.debounce(utils.bind(_hideBefore, this), 3500);
    _hideBeforeDebounce = debounce(_hideBefore, 3500);

    // _feedInterestingChangeDebounce = utils.debounce(_feedInterestingChange, 3500);
    _feedInterestingChangeDebounce = _feedInterestingChange;

    reInit();

    // checkNeedRestore();
    _addBeforeUnload();
    _attachEvents();
    _attachScroll();

    on(events.fetchNext, () => {_getNextItems()});

    //     this.on("end", i.bind(this._showOverflowMessage, this));
    _isFeedOverflow = $(".no_items_msg").length > 0;
  } else {
    // checkNeedRestore();
    _addBeforeUnload();
  }



  const feed = {
    checkCurrentPage: _checkCurrentPage,
    pageWithFeed: function(){
      var pathname = window.location.pathname,
          test = ["/", "/index", "/bookmarks"],
          regTest = [/^\/magazine\/.*$/, /^\/article\/by-magazine\/.*$/, /^\/articles\/category\/.*$/],
          match = false;

      if (test.indexOf(pathname) !== -1) {
        return true;
      }
      forEach(regTest, function(item) {
        if (item.test(pathname)) {
          match = true;
        }
      });

      return match;
    },
    goBack: function(){
      // check history length and container was init on page with feed
      if (_getHistoryLength() > 1 && _wasInitOnPageWithFeed) {
        window.history.back();
      } else {
        window.location = '/';
      }
    },
    fetchNextEvent: events.fetchNext
  };

  export default feed
